// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"179":"5de54287","242":"c70cd03e","460":"5de54287","829":"5de54287"}[chunkId] + ".chunk.css";
};